<template>
  <el-dialog
    :title="'批量' + date.title"
    v-model="dialogVisible"
    append-to-body
    class="batch"
    header-class="batch-header-dialog"
    width="1150px"
    :style="{ '--el-dialog-padding-primary': 0 }"
  >
    <div class="batch-content" style="padding: 13px 20px;">
      <div class="title">请选择你要{{ date.title }}的数据</div>
      <div class="radio-list">
        <el-radio
          v-model="radio"
          :label="1"
          :disabled="!date.dateLen || date.dateLen === 0"
          >当前勾选的数据，共{{ date.dateLen || 0 }}条</el-radio
        >
      </div>
      <div class="radio-list">
        <el-radio v-model="radio" :label="2" :disabled="!isDisabledSearch"
          >{{ date.title }}筛选后的数据</el-radio
        >
      </div>
      <div class="radio-list">
        <el-radio v-model="radio" :label="3">
          <el-date-picker
            v-model="radioTime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="YYYY-MM-DD"
          />
        </el-radio>
      </div>
      <template v-if="date.operate === 'export' || date.operate === 'customImport'">
        <div class="export-hint">{{ date.operate === 'customImport' ? '*单次导出数据最入1000条' : '*单次导出数据最多1万条' }}</div>
        <div class="export-wrap">
          <el-row>
            <el-col :span="18">
              <div class="list-field">
                <div class="title">
                  <span>选择字段</span>
                  <template v-if="checkboxCenter.length > 0">
                    <el-checkbox v-model="isCheckbox" @change="allCheckboxFun"
                      >全选</el-checkbox
                    >
                  </template>
                </div>
                <div v-if="checkboxCenter.length > 0" class="content">
                  <div class="export-column">
                  <div v-for="(item, index) in leftItems" :key="`left-${item.title || item.name || index}`">
                    <div v-if="item.type === 'relation-user' || item.type === 'organization' || item.type === 'roule'" class="checkbox-group">
                      <el-checkbox
                        @change="changeFun"
                        v-model="item.checked"
                        >{{ item.name }}</el-checkbox
                      >
                      <el-checkbox
                        @change="changeIdFun"
                        v-model="item.id"
                        class="id-checkbox"
                        >编号</el-checkbox
                      >
                    </div>
                    <el-checkbox v-else @change="changeFun" v-model="item.checked"
                      >{{ item.name }}</el-checkbox
                    >
                  </div>
                </div>
                <div v-if="rightItems.length > 0" class="export-column">
                  <div v-for="(item, index) in rightItems" :key="`right-${item.title || item.name || index}`">
                    <div v-if="item.type === 'relation-user' || item.type === 'organization' || item.type === 'roule'" class="checkbox-group">
                      <el-checkbox
                        @change="changeFun"
                        v-model="item.checked"
                        >{{ item.name }}</el-checkbox
                      >
                      <el-checkbox
                        @change="changeIdFun"
                        v-model="item.id"
                        class="id-checkbox"
                        >编号</el-checkbox
                      >
                    </div>
                    <el-checkbox v-else @change="changeFun" v-model="item.checked"
                      >{{ item.name }}</el-checkbox
                    >
                  </div>
                </div>
              </div>
            </div>
          </el-col>
            <el-col :span="6">
              <div class="list-choose">
                <div class="title">
                  <span>{{ date.operate === 'customImport' ? '导入更新字段' : '导出字段' }}</span>
                  <el-link icon="el-icon-delete" @click="clearCheckList" :underline="false">清空</el-link>
                </div>
                <div class="content">
                  <el-scrollbar>
                    <draggable
                      ref="scrollBottom"
                      v-model="checkList"
                      style="width: 100%"
                      animation="200"
                    >
                      <div
                        class="sort-list"
                        v-for="(list, index) in checkList"
                        :key="index"
                        :draggable="true"
                      >
                        <i class="iconfont icon-tuodong" />
                        <span>{{ list.name }}</span>
                      </div>
                    </draggable>
                  </el-scrollbar>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>      
      </template>
      <template v-else-if="date.operate === 'update'">
        <div class="export-hint">*单次导出数据最多1万条</div>
        <div class="update-button">
          <el-popover placement="bottom" width="200" trigger="hover">
            <template #reference>
              <el-button>添加字段</el-button>
            </template>
            <el-scrollbar style="height: 300px">
              <div
                v-if="isViewArchive"
                :class="[
                  'add-size-list',
                  isListArchive ? 'add-size-list-active' : '',
                ]"
                @click="isListArchive = true"
              >
                归档状态
              </div>
              <div
                :class="[
                  'add-size-list',
                  upList.length > 0 ? 'add-size-list-active' : '',
                ]"
                v-for="(item, index) in upTemplate"
                :key="'temp' + index"
                @click="selectTemp(item)"
              >
                {{ item.name }}
                <!--              <i class="iconfont icon-tongguo-" />-->
              </div>
            </el-scrollbar>
          </el-popover>
        </div>
        <!-- 归档字段控制显示 -->
        <div v-if="isListArchive" class="update-list">
          <div class="update-list-center">归档</div>
          <div class="update-list-text">批量修改为</div>
          <el-select v-model="isarchive">
            <el-option :value="0" label="未归档" />
            <el-option :value="1" label="已归档" />
          </el-select>
        </div>
        <div
          class="update-list"
          v-for="(item, index) in upList"
          :key="'update' + index"
        >
          <div class="update-list-center">{{ item.name }}</div>
          <div class="update-list-text">
            <el-select
              
              v-model="item.op"
              style="width: 90px"
              @change="(val) => switchOp(val, item)"
            >
              <el-option value="固定值" label="固定值" />
              <el-option value="条件值" label="条件值" />
            </el-select>
          </div>
          <!-- 这个是固定值的 -->
          <div class="update-list-right" v-if="item.op === '固定值'">
            <el-input
              v-if="
                item.type === 'text' ||
                item.type === 'textarea' ||
                item.type === 'number'
              "
              
              :type="item.type === 'number' ? 'number' : 'text'"
              v-model="item.value"
            />
            <el-select
              v-else-if="item.type === 'checkbox' || item.type === 'radio'"
              :multiple="item.type === 'checkbox'"
              style="width: 160px;"
              v-model="item.value"
            >
              <el-option
                v-for="(list, indexList) in item.sels"
                :key="item.title + indexList"
                :value="list.value || list"
                :label="list.label || list"
              />
            </el-select>
            <el-date-picker
              v-else-if="item.type === 'date'"
              style="width: 160px"
              v-model="item.value"
              :type="
                item.match === 'yyyy-MM-dd' || item.match === 'yyyy-MM-dd ww'
                  ? 'date'
                  : item.match === 'yyyy-MM'
                  ? 'month'
                  : 'datetime'
              "
              placeholder="选择日期时间"
              :value-format="
                item.match === 'yyyy-MM-dd ww' ? 'YYYY-MM-DD' : item.match === 'yyyy-MM' ? 'YYYY-MM-DD' : item.match.toUpperCase()
              "
            >
            </el-date-picker>
            <div
              v-else-if="item.type === 'relation-user'"
              class="update-list-user"
              @click="selectUser(item.value, { f: index, val: 'value' })"
            >
              <template v-if="!item.value || item.value.length === 0">
                请选择联系人
              </template>
              <el-tag
                v-else
                v-for="(tag, indexTag) in item.value"
                :key="tag.userId"
                closable
                @close="closeTag(item.value, indexTag)"
              >
                {{ tag.realname }}
              </el-tag>
            </div>
          </div>
          <!-- 条件值的 -->
          <div v-else>
            <div
              class="up-list-right-mom"
              v-for="(list, indexList) in item.condition"
              :key="item.title + '-' + indexList"
            >
              <div class="mom-text">当前值为</div>
              <div v-for="(it, i) in ['condition', 'value']" :key="`cond-${i}`" class="cond-wrap">
                <div class="update-list-right">
                  <el-input
                    v-if="
                      item.type === 'text' ||
                      item.type === 'textarea' ||
                      item.type === 'number'
                    "
                    
                    :type="item.type === 'number' ? 'number' : 'text'"
                    v-model="list[it]"
                  />
                  <el-select
                    v-else-if="item.type === 'checkbox' || item.type === 'radio'"
                    :multiple="item.type === 'checkbox'"
                    
                    v-model="list[it]"
                  >
                    <el-option
                      v-for="(list, indexList) in item.sels"
                      :key="item.title + indexList"
                      :value="typeof list ? list.value : list"
                      :label="typeof list ? list.label : list"
                    />
                  </el-select>
                  <el-date-picker
                    v-else-if="item.type === 'date'"
                    style="width: 160px"
                    
                    v-model="list[it]"
                    :type="
                      item.match === 'yyyy-MM-dd' ||
                      item.match === 'yyyy-MM-dd ww'
                        ? 'date'
                        : item.match === 'yyyy-MM'
                        ? 'month'
                        : 'datetime'
                    "
                    :value-format="
                      item.match === 'yyyy-MM-dd ww' ? 'YYYY-MM-DD' : item.match === 'yyyy-MM' ? 'YYYY-MM-DD' : item.match.toUpperCase()
                    "
                    placeholder="选择日期时间"
                  >
                  </el-date-picker>
                  <div
                    v-else-if="item.type === 'relation-user'"
                    class="update-list-user"
                    @click="
                      selectUser(list[it], { f: index, val: it, z: indexList })
                    "
                  >
                    <template v-if="!list[it] || list[it].length === 0">
                      请选择联系人
                    </template>
                    <el-tag
                      v-else
                      v-for="(tag, indexTag) in list[it]"
                      :key="tag.userId"
                      closable
                      @close="closeTag(list[it], indexTag)"
                    >
                      {{ tag.realname }}
                    </el-tag>
                  </div>
                </div>
                <div v-if="i === 0" class="mom-text mom-text1">更改为</div>
              </div>
              <el-icon class="el-icon-remove-outline" @click="delCondition(item, indexList)"><Remove /></el-icon>
            </div>
          </div>
          <el-icon class="el-icon-circle-plus-outline" @click="addCondition(item)" v-if="item.op === '条件值'">
            <CirclePlus />
          </el-icon>
           <el-icon class="el-icon-delete" @click="upList.splice(index, 1)">
            <Delete />
           </el-icon>
        </div>
      </template>
    </div>
    <template #footer>
      <div style="padding: 20px; padding-top: 10px;">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="save">立即执行</el-button>
      </div>
    </template>
    <multiple-choice
      ref="multipleChoiceRef"
      v-on:fromMultipleChoice="fromMultipleChoice"
    ></multiple-choice>
  </el-dialog>
</template>

<script>
import { getapprovalfeild, isopenarchive, getuserexportcontent } from '@/port/clientSide/workbench'
import multipleChoice from '@/components/common/multipleChoice'
import { VueDraggable as draggable } from 'vue-draggable-plus'
export default {
  name: "batchDialog",
  components: {
    multipleChoice,
    draggable
  },
  /**
   * date 结构
   * {
   *   title: ''  // 标题
   *   repeat: false  // 是否启用二次确认
   *   operate: 'del' // 操作 del 删除 update 修改 export 导出
   *   dateLen: 0 // 选中数据条数
   *   center: [] // 导出使用（标题数据）
   * }
   * **/
  props: ['visible', 'date', 'approvalId'],
  data () {
    return {
      dialogVisible: false,
      radio: '',
      radioTime: '',
      // 导出
      isCheckbox: false,
      checkboxCenter: [],
      // 修改
      upTemplate: [],
      upList: [],
      isarchive: '',
      isViewArchive: false,
      isListArchive: false,
      // 联系人选择暂存
      reUser: '',
      checkList: [] // 导出字段列表
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler (val) {
        if (val) {
          this.radio = ''
          this.radioTime = ''
          this.isCheckbox = false
          this.checkboxCenter = []
          this.upTemplate = []
          this.upList = []
          this.isarchive = ''
          this.reUser = ''
          this.isViewArchive = false
          this.isListArchive = false
          if (this.date.operate === 'export' || this.date.operate === 'customImport') {
            // 确保每个对象都有必要的属性
            this.checkboxCenter = this.date.center.map(item => ({
              ...item,
              checked: this.date.operate === 'customImport' ? (item.checked || false) : false,
              id: item.type === 'relation-user' || item.type === 'organization' || item.type === 'roule' ? false : undefined
            }))
            // 判断是否全选了
            this.isAllCheckboxFun()
            // 获取已导出字段
            if (this.date.operate === 'export') {
              this.getUserExportContent()
            }
            if (this.date.operate === 'customImport') {
              this.checkList = this.checkboxCenter.filter(item => { return item.checked })
            }
          }
          if (this.date.operate === 'update' && this.approvalId) {
            this.getArchive()
            this.getModel()
          }

          if (this.date.dateLen || this.date.dateLen !== 0) {
            this.radio = 1
          } else if (this.isDisabledSearch) {
            this.radio = 2
          } else {
            this.radio = 3
          }
          this.dialogVisible = true
        }
      }
    },
    dialogVisible: {
      immediate: true,
      handler (val) {
        if (!val) {
          this.$emit('update:visible', false)
          this.$emit('close')
        }
      }
    }
  },
  computed: {
    isDisabledSearch() {
      let date = this.date.batchQuery
      const batchfixQuery = this.date.batchfixQuery || {}
      if (!date && !Object.keys(batchfixQuery).length) return false
      try {
        date = typeof date === 'string' ? JSON.parse(date) : date
        if ((typeof date === 'object' && Object.keys(date).length) && (typeof batchfixQuery === 'object' && Object.keys(batchfixQuery).length)) return false
        return true
      } catch (error) {
        return true
      }
    },
    leftItems() {
      const len = this.checkboxCenter.length
      if (!len) return []
      const mid = Math.ceil(len / 2)
      return this.checkboxCenter.slice(0, mid)
    },
    rightItems() {
      const len = this.checkboxCenter.length
      if (!len) return []
      const mid = Math.ceil(len / 2)
      return this.checkboxCenter.slice(mid)
    }
  },
  methods: {
    // 判断是否开启了归档
    async getArchive () {
      const res = await isopenarchive({ approvalId: this.approvalId })
      if (res.code === 0) {
        this.isViewArchive = res.data
      }
    },
    // 移除标签
    closeTag (item, i) {
      item.splice(i, 1)
    },
    // 联系人选择返回
    fromMultipleChoice (val) {
      const arr = (val.checkedUserArr || []).map(item => {
        const obj = {
          realname: item.realname,
          userId: item.userId
        }
        if (item.orgname) obj.orgname = item.orgname
        return obj
      })
      if (!this.reUser.z && this.reUser.z !== 0) {
        this.upList[this.reUser.f][this.reUser.val] = arr
      } else {
        this.upList[this.reUser.f].condition[this.reUser.z][this.reUser.val] = arr
      }
    },
    // 联系人选择
    selectUser (item, i) {
      this.reUser = i
      const obj = {
        radio_: false,
        isorgs: true,
        isrole: false,
        onlyUser: true,
        checkedUserArr: item
      }
      this.$refs.multipleChoiceRef.multipleChoiceMethod(obj)
    },
    // 删除条件值
    delCondition (item, i) {
      if (item.condition.length === 1) {
        item.condition = [{"condition":"", "value":""}]
      } else {
        item.condition.splice(i, 1)
      }
    },
    // 添加条件值
    addCondition (item) {
      const obj = {"condition":"", "value":""}
      item.condition.push(obj)
    },
    // 条件切换监听
    switchOp (val, item) {
      const condition = val === '固定值' ? '' : [{"condition":"", "value":""}]
      item.value = ''
      item.condition = condition
    },
    // 选中模板字段(后台说这里只能添加一个字段)
    selectTemp (item) {
      if (this.upList.length === 0) {
      // if (!this.isExist(item.title)) {
        const obj = {
          ...item,
          op: '固定值',
          condition: '',
          value: ''
        }
        if ((item.type === 'radio' || item.type === 'checkbox') && item.sels) obj.sels = typeof item.sels === 'string' ? JSON.parse(item.sels) : item.sels
        this.upList.push(obj)
      }
    },
    // 字段是否已选择
    isExist (val) {
      if (!this.upList || this.upList.length === 0) return false
      return (this.upList || []).includes(item => item.title === val)
    },
    // 获取模板字段
    async getModel () {
      const res = await getapprovalfeild({ approvalId: this.approvalId })
      if (res.code === 0) {
        this.upTemplate = res.data.map(it => {
          if (it.type === 'checkbox' && typeof it.sels === 'string') {
            try {
              it.sels = JSON.parse(it.sels)
            } catch (err) { console.log(err) }
          }
          return it
        })
      }
    },
    // 获取已导出的字段
    async getUserExportContent () {
      const res = await getuserexportcontent({ approvalId: this.approvalId })
      if (res.code === 0) {
        if(res.data && res.data.length > 0) {
          this.checkList = res.data
          // 先将checkboxCenter中所有字段的checked状态重置为false
          this.checkboxCenter.forEach(item => {
            item.checked = false
            // 重置特定类型的id状态
            if (item.type === 'relation-user' || item.type === 'organization' || item.type === 'roule') {
              item.id = false
            }
          })
          // 同步更新checkboxCenter中对应字段的状态
          this.checkList.forEach(listItem => {
            // 在checkboxCenter中找到对应的字段
            const checkboxItem = this.checkboxCenter.find(item => 
              item.title === listItem.title
            )
            if (checkboxItem) {
              // 使用$set确保响应式更新
              this.$set(checkboxItem, 'checked', true)
              
              // 如果是特定类型且有id，同步id状态
              if ((listItem.type === 'relation-user' || listItem.type === 'organization' || listItem.type === 'roule') && listItem.id) {
                this.$set(checkboxItem, 'id', listItem.id)
              }
            }
          })
          
          // 更新全选状态
          this.isAllCheckboxFun()
        } else {
          // 如果接口返回空数据，清空所有选中状态
          this.checkList = []
          this.checkboxCenter.forEach(item => {
            item.checked = false
            if (item.type === 'relation-user' || item.type === 'organization' || item.type === 'roule') {
              item.id = false
            }
          })
          this.isCheckbox = false
        }
      }
    },
    // 选择
    changeFun (val) {
      if (val) {
        this.isAllCheckboxFun()
      } else {
        this.isCheckbox = false
      }
      // 同步更新checkList
      this.syncCheckList()
    },
    // 编号选择变化处理
    changeIdFun () {
      // 同步更新checkList中对应字段的id状态
      this.syncCheckList()
    },
    // 同步checkboxCenter和checkList
    syncCheckList() {
      // 先更新现有checkList中字段的属性
      this.checkList.forEach(listItem => {
        const checkboxItem = this.checkboxCenter.find(item => 
          item.name === listItem.name && item.type === listItem.type
        )
        
        if (checkboxItem) {
          // 更新checked状态
          listItem.checked = checkboxItem.checked
          
          // 组织、角色、联系人更新id状态
          if (listItem.type === 'relation-user' || listItem.type === 'organization' || listItem.type === 'roule') {
            listItem.id = checkboxItem.id || false
          }
        }
      })
      
      // 移除已取消选中的字段
      this.checkList = this.checkList.filter(listItem => {
        const checkboxItem = this.checkboxCenter.find(item => 
          item.name === listItem.name && item.type === listItem.type
        )
        return checkboxItem && checkboxItem.checked
      })
      
      // 添加新选中的字段到checkList末尾
      this.checkboxCenter.forEach(checkboxItem => {
        if (checkboxItem.checked) {
          // 检查是否已经存在于checkList中
          const exists = this.checkList.some(listItem => 
            listItem.name === checkboxItem.name && listItem.type === checkboxItem.type
          )
          
          if (!exists) {
            // 添加新字段到末尾
            const newItem = {
              name: checkboxItem.name,
              type: checkboxItem.type,
              title: checkboxItem.title,
              checked: checkboxItem.checked
            }
            
            // 组织、角色、联系人添加id
            if (checkboxItem.type === 'relation-user' || checkboxItem.type === 'organization' || checkboxItem.type === 'roule') {
              newItem.id = checkboxItem.id || false
            }
            
            this.checkList.push(newItem)
          }
        }
      })
    },
    // 判断是否全选了
    isAllCheckboxFun () {
      let a = 0
      for (const i of this.checkboxCenter) {
        if (i.checked) a += 1
      }
      this.isCheckbox = a === this.checkboxCenter.length
    },
    // 全选
    allCheckboxFun (val) {
      this.checkboxCenter = this.checkboxCenter.map(item => {
        item.checked = val
        return item
      })
      // 同步更新checkList
      this.syncCheckList()
    },
    // 清空已选中的字段
    clearCheckList () {
      this.checkList = []
      // 同步清空checkboxCenter中所有字段的选中状态
      this.checkboxCenter.forEach(item => {
        item.checked = false
        // 如果是特定类型，同时清空id的选中状态
        if (item.type === 'relation-user' || item.type === 'organization' || item.type === 'roule') {
          item.id = false
        }
      })
      // 更新全选状态
      this.isCheckbox = false
    },
    save () {
      // 必填项
      if (!this.radio) {
        this.$message.error('请选择条件!')
        return false
      }
      if (this.radio === 1 && !this.date.dateLen) {
        this.$message.error('您未选中数据!')
        return false
      } else if (this.radio === 3 && (!this.radioTime || this.radioTime.length === 0)) {
        this.$message.error('请选择开始结束时间!')
        return false
      }
      // 如果是删除的话，加一个二次确认
      if (this.date.repeat) {
        this.$confirm('此操作将永久' + this.date.title + '该数据，是否操作？', {
          confirmButtonClass: 'el-button--yeprimary',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.returnEmit()
          this.dialogVisible = false
        })
      } else {
        this.returnEmit()
      }
    },
    returnEmit () {
      const obj = {
        radio: this.radio
      }
      if (this.radio === 3) obj.time = this.radioTime
      if (this.date.operate === 'export') obj.center = this.checkboxCenter
      if (this.date.operate === 'update') {
        obj.conditionconfig = this.upList
        obj.isarchive = this.isarchive
      }
      this.$emit('batch', {...obj, center: this.checkList})
      this.dialogVisible = false
    }
  }
}
</script>

<style scoped lang="scss">
.batch {
  .el-dialog__header {
    background-color: #f5f5f5;
  }
  .el-dialog__body {
    padding-top: 13px;
    padding-bottom: 13px;
  }
  .title,
  .radio-list {
    font-size: 16px;
    color: #333333;
    padding-bottom: 5px;
  }
  .title {
    padding-bottom: 20px;
  }
  .radio-list:last-child {
    padding-bottom: 0;
  }
  .export-hint {
    font-size: 12px;
    color: #e47470;
    line-height: 16px;
    padding-left: 19px;
    padding-bottom: 9px;
  }
  .export-wrap {
    max-height: 550px;
    border: 1px solid #CBCCCC;
    .title {
      height: 37px;
      line-height: 37px;
      padding: 0 20px;
    }
  }
  .list-field {
    border-right: 1px solid #CBCCCC;
    .title {
      background-color: #F1F2F2;
      span {
        font-size: 16px;
        color: #000;
        margin-right: 14px;
      }
    }
    .content {
      display: flex;
      max-height: 470px;
      overflow: auto;
      .export-column {
        height: max-content;
        flex: 1;
        display: flex;
        flex-direction: column;
        padding: 10px;
        &:first-child {
          border-right: 1px solid #CCCCCB;
        }
        .el-checkbox {
          margin-bottom: 4px;
          margin-right: 0;
          
          &:last-child {
            margin-bottom: 0;
          }
          &.id-checkbox {
            margin-left: 20px;
            margin-bottom: 0;
            :deep(.el-checkbox__input.is-checked .el-checkbox__inner) {
              background-color: #A1DD74;
              border-color: #A1DD74;
            }
          }
        }
        .checkbox-group {
          display: flex;
          align-items: center;
          margin-bottom: 4px;
          
          .el-checkbox {
            margin-bottom: 0;
            flex-shrink: 0;
          }
        }
      }
    }
  }
  .list-choose {
    .title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      span {
        font-size: 14px;
        color: #333;
      }
      .el-link {
        color: #F56C6C;
      }
    }
    .content {
      max-height: 470px;
      overflow: auto;
      :deep(.el-scrollbar) {
        overflow: hidden;
        height: 100%;
      }
      .sort-list {
        height: 22px;
        line-height: 22px;
        color: #666;
        font-size: 14px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        cursor: pointer;
        padding: 0 10px;
        border-radius: 2px;
        transition: color 0.2s ease;
        &.hover {
          color: #4F85FF;
        }
        .iconfont {
          float: left;
          margin-right: 8px;
          color: #999;
          font-size: 12px;
        }
        span {
          display: inline-block;
          max-width: calc(100% - 20px);
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
  .export-center {
    padding-bottom: 9px;
    display: flex;
    flex-direction: column;
    max-height: 470px;
    overflow: auto;
  }
  .update-button {
    padding-top: 10px;
    padding-bottom: 10px;
    text-align: right;
  }
  .update-list {
    padding-bottom: 20px;
    display: flex;
    align-items: self-start;
    .update-list-text {
      padding-left: 10px;
      padding-right: 10px;
      font-size: 14px;
      color: #333333;
      line-height: 32px;
    }
    .update-list-center {
      width: 155px;
      height: 18px;
      line-height: 18px;
      border-radius: 2px;
      border: 1px solid #d8d8d8;
      padding: 6px 14px;
      font-size: 14px;
      color: #333333;
    }
    .update-list-right {
      max-width: 155px;
      .update-list-user {
        min-width: 135px;
        max-width: 300px;
        border: 1px solid #d8d8d8;
        border-radius: 2px;
        text-align: center;
        padding: 5px 10px;
        line-height: 22px;
        cursor: pointer;
      }
    }
    .icon-shezhi21 {
      color: #4e86ff;
      font-size: 22px;
      cursor: pointer;
    }
    .el-icon-delete {
      color: #e47470;
      margin-left: 10px;
      font-size: 22px;
      cursor: pointer;
      padding-top: 4px;
    }
    .el-icon-circle-plus-outline {
      font-size: 24px;
      cursor: pointer;
      padding-top: 4px;
    }
  }
  .up-list-right-mom {
    display: flex;
    align-items: center;
    width: 480px;
    margin-bottom: 10px;
    .mom-text {
      margin-right: 10px;
    }
    .mom-text1 {
      margin-left: 10px;
    }
    .el-icon-remove-outline {
      font-size: 24px;
      margin-left: 10px;
      cursor: pointer;
    }
  }
}
.add-size-list {
  line-height: 40px;
  color: #333333;
  font-size: 14px;
  cursor: pointer;
  position: relative;
  &:hover {
    background-color: #f1f8ff;
  }
  /*
  .icon-tongguo- {
    display: none;
  }
*/
}
.add-size-list-active {
  color: #dcdcdc;
  /*
  .icon-tongguo- {
    display: block;
    color: #4e86ff;
    position: absolute;
    right: 0;
  }
*/
}
</style>
